import { render, staticRenderFns } from "./ActivityChart.vue?vue&type=template&id=56477af6&scoped=true"
import script from "./ActivityChart.vue?vue&type=script&lang=ts"
export * from "./ActivityChart.vue?vue&type=script&lang=ts"
import style0 from "./ActivityChart.vue?vue&type=style&index=0&id=56477af6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56477af6",
  null
  
)

export default component.exports